import React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import Table from '../../components/Table';
import * as _ from 'lodash';
import { createSidebar } from '../../redux/actions/general/sidebar';
import { listActiveModules } from '../../redux/actions/general/active_modules';
import Tooltip from '../../components/Tooltip';
import { setNotification } from '../../redux/actions/general/notification';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import DeleteIcon from '../../assets/images/delete-15x15.svg';
import {
  listCompanyFolders,
  readCompanyFolder,
  updateCompanyFolder,
  deleteCompanyFolder,
} from '../../redux/actions/table/company_folders';
import { __, dateFrom, validateForm } from '../../core/utils';
import { setPlusActions } from '../../redux/actions/general/plus';
import store from '../../core/store';
import autobind from 'autobind-decorator';
import { bindActionCreators } from 'redux';
import Avatar from '../../components/Avatar';
import TableNA from '../../components/TableNA';
import styles from '../../styles/views/company/CompanyFolders.scss';
import CloseBigIcon from '../../assets/images/close-big-15x15.svg';
import { get, includes, omit, find, size, uniqueId, map, take } from 'lodash';
import EditCompanyFoldersForm from '../../forms/company_folders/EditCompanyFoldersForm';

const mapStateToProps = (state) => {
  return {
    table: state.table['company_folders'],
    auth: state.auth,
    company: get(state.companies, state.auth.company.id, []),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.company_folders/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

@connect(mapStateToProps, mapDispatchToProps)
class CompanyFolders extends Component {
  constructor(props) {
    super(props);

    this.state = {
      team_roles: [],
    };
  }

  componentDidMount() {
    listActiveModules();

    let items = [
      {
        title: __('submenu.title.company-details'),
        link: () => '/company/details',
      },
      {
        title: __('submenu.title.offices'),
        link: () => '/company/offices',
      },
      {
        title: __('company-settings.submenu.title.brands'),
        link: () => '/company/brands',
      },
      {
        title: __('company-settings.submenu.title.disciplines'),
        link: () => '/company/disciplines',
      },
      {
        title: __('submenu.title.market'),
        link: () => '/company/market',
      },
      {
        title: __('submenu.title.company_holidays'),
        link: () => '/company/company_holidays',
      },
      {
        title: __('submenu.title.company_positions'),
        link: () => '/company/company_positions',
      },
      {
        title: __('submenu.title.company_segments'),
        link: () => '/company/company_segments',
      },
      {
        title: __('submenu.title.company_benefits'),
        link: () => '/company/company_benefits',
      },
      {
        title: __('submenu.title.company_folders'),
        link: () => '/company/company_folders',
        active: true,
      },
    ];

    if (
      includes(
        this.props.auth?.permissions,
        'view.permissions.in.permission.manager'
      )
    )
      items.push({
        title: __('submenu.title.company_roles_and_permissions'),
        link: () => '/company/company_roles_and_permissions',
      });

    createSidebar({
      title: __('topbar.account.company-settings'),
      items,
      // {
      //     title: __("submenu.title.subscription-and-billing"),
      //     link: () => "/company/subscription"
      // }
    });

    setPlusActions([
      {
        title: __('company_folders.table.button.create'),
        onClick: () =>
          this.props.actions.setTableParams({
            wizard_active: true,
          }),
      },
    ]);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.table.clicked_row &&
      this.props.table.clicked_row !== prevProps.table.clicked_row
    ) {
      if (!prevProps.table.clicked_row) {
        this.setState({ preview: undefined });
      }

      readCompanyFolder(this.props.table.clicked_row).then(({ response }) => {
        this.setState({ preview: response.data });
      });
    }
  }

  _handleOpacity(value, row) {
    return !row.deactivated ? (
      value
    ) : (
      <div className={styles.hidden}>{value}</div>
    );
  }

  @autobind
  _handleSubmit(formData) {
    const user_ids = map(formData.user_ids, 'id');

    return validateForm(
      updateCompanyFolder(formData.id, {
        ...omit(formData, ['id']),
        user_ids,
        parent_id: null,
      }).then(() => {
        listCompanyFolders();

        readCompanyFolder(getURLParam('id')).then(({ response }) => {
          this.setState({ preview: response.data });
        });

        setNotification(
          __('company-settings.folders.notification.success-saved')
        );
      })
    );
  }

  render() {
    const columns = [
      {
        key: 'name',
        name: __('table.columns.company-folder.name'),
        required: true,
        value: (value) => <Tooltip text={value}>{value}</Tooltip>,
      },
      {
        key: 'permission',
        name: __('table.columns.company-folder.permission'),
        required: true,
        value: (value, row) => {
          // const findPermissions = find(row.permissions, [
          //   'permissions',
          //   { permission: 'view' },
          // ]);

          const findPermissions = find(row.permissions, { permission: 'view' });

          const users = findPermissions?.users;

          const roles = findPermissions?.roles;

          return (
            <div className={styles.users}>
              {size(users) == 0 && <TableNA />}
              {/* {size(users) == 1 &&
                map(take(users, 1), (user, i) => (
                  <Avatar key={i} {...user} name={user.fullname} />
                ))}
              {size(users) > 1 && (
                <Tooltip text={map(users, 'fullname').join('\n')}>
                  <div className={styles.more}>
                    <span>{size(users)}</span>
                  </div>
                </Tooltip>
              )} */}
              <Tooltip text={map(roles, 'name').join('\n')}>
                <div>{map(roles, 'name').join(', ')}</div>
              </Tooltip>
            </div>
          );
        },
      },
    ];

    const singleActions = (id) => {
      let actions = [];

      actions.push([
        <Tooltip
          text={__('table.folders.actions.delete.tooltip')}
          key={uniqueId()}
        >
          <DeleteIcon
            onClick={(e) => {
              e.stopPropagation();

              showAlertbox({
                color: 'red',
                title: __('general.alert.are-you-sure'),
                description: __(
                  'table.folders.actions.delete.tooltip.this-process-cannot-undone'
                ),
                buttons: [
                  {
                    color: 'lightGray',
                    text: __('general.alert.no-close'),
                    onClick: 'close',
                  },
                  {
                    color: 'gray',
                    text: __('general.alert.yes-delete'),
                    onClick: () => {
                      deleteCompanyFolder(id).then(() => {
                        hideAlertbox();

                        setNotification(
                          __(
                            'table.folders.actions.delete.selected-company-folder-deleted'
                          )
                        );

                        listCompanyFolders();

                        this.props.actions.setTableParams({
                          selected_rows: undefined,
                        });
                      });
                    },
                  },
                ],
              });
            }}
          />
        </Tooltip>,
      ]);

      return actions;
    };

    const preview = () => {
      const findPermissions = find(this.state.preview?.permissions, [
        'permission',
        'view',
      ]);

      const users = findPermissions?.users;

      const roles = findPermissions?.roles;

      return (
        <div className={styles.preview}>
          <div className={styles.header}>
            <div className={styles.title}>
              <span>{get(this.state, 'preview.name')}</span>
              <CloseBigIcon
                onClick={() =>
                  this.props.actions.setTableParams({
                    clicked_row: undefined,
                  })
                }
              />
            </div>

            <div className={styles.actions}>
              <div className={styles.actionWrapper}>
                <Tooltip
                  text={__('company-folders.flyout.tooltip.delete-folder')}
                  // key={_.uniqueId()}
                  key={uniqueId()}
                >
                  <DeleteIcon
                    onClick={(e) => {
                      e.stopPropagation();

                      const folderId = get(this.state, 'preview.id');
                      showAlertbox({
                        color: 'red',
                        title: __('general.alert.are-you-sure'),
                        description: __(
                          'table.folders.actions.delete.tooltip.this-process-cannot-undone'
                        ),
                        buttons: [
                          {
                            color: 'lightGray',
                            text: __('general.alert.no-close'),
                            onClick: 'close',
                          },
                          {
                            color: 'gray',
                            text: __('general.alert.yes-delete'),
                            onClick: () => {
                              // deleteCompanyFolder(id).then(() => {
                              deleteCompanyFolder(folderId).then(() => {
                                hideAlertbox();

                                setNotification(
                                  __(
                                    'table.folders.actions.delete.selected-company-folder-deleted'
                                  )
                                );

                                listCompanyFolders();

                                this.props.actions.setTableParams({
                                  selected_rows: undefined,
                                });
                              });
                            },
                          },
                        ],
                      });
                    }}
                  />
                </Tooltip>
              </div>
            </div>
          </div>
          <div className={styles.scroller}>
            <div className={styles.form}>
              <EditCompanyFoldersForm
                onSubmit={this._handleSubmit}
                initialValues={{
                  ..._.pick(get(this.state, 'preview'), ['id', 'name']),
                  user_ids: map(users, (user) => ({
                    ...user,
                    name: user.fullname,
                  })),
                  // role_ids: map(roles, (role) => ({
                  //   ...role,
                  // })),
                  role_ids: map(roles, 'id'),
                }}
              />
            </div>
          </div>
        </div>
      );
    };

    //const company_id = this.props.auth.company.id;

    return (
      <Table
        listAction={listCompanyFolders}
        name='company_folders'
        title={__('submenu.title.company_folders')}
        columns={columns}
        singleActions={singleActions}
        onLoad={() => listActiveModules()}
        preview={get(this.state, 'preview') ? preview() : []}
      />
    );
  }
}

export default CompanyFolders;
